import { createDerivedWritableAtom } from "../../utils";
import { dataChannelAppStateAtom } from "../../video-sdk/core/message/atoms";
import { createDataChannelPropertyAtom } from "../../video-sdk/core/message/utils";
import {
  WritableDataChannelAtom,
  type ConsentStatus,
  type ConsentUpdateSource,
} from "../../video-sdk";

const providerAtom = createDerivedWritableAtom(
  dataChannelAppStateAtom,
  "provider",
);

export const providerConsentAtom: WritableDataChannelAtom<ConsentStatus> =
  createDataChannelPropertyAtom(providerAtom, "consent");

const patientAtom = createDerivedWritableAtom(
  dataChannelAppStateAtom,
  "patient",
);

export const patientConsentAtom: WritableDataChannelAtom<ConsentStatus> =
  createDataChannelPropertyAtom(patientAtom, "consent");

export const patientConsentUpdateSourceAtom: WritableDataChannelAtom<ConsentUpdateSource> =
  createDataChannelPropertyAtom(patientAtom, "updateSource");

export const isWhiteboardModeAtom: WritableDataChannelAtom<boolean> =
  createDataChannelPropertyAtom(dataChannelAppStateAtom, "isWhiteboardMode");
